import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentProcessor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.723 7.747C1.723 4.368 4.461 1.63 7.84 1.63C9.623 1.63 11.229 2.393 12.346 3.609C12.533 3.812 12.519 4.129 12.316 4.316C12.112 4.502 11.797 4.489 11.61 4.286C10.674 3.267 9.331 2.63 7.84 2.63C5.014 2.63 2.723 4.92 2.723 7.747C2.723 7.757 2.719 7.767 2.719 7.777L3.997 7.758C4.162 7.756 4.259 7.942 4.162 8.075L2.327 10.599C2.248 10.706 2.088 10.708 2.006 10.603L0.099 8.135C-0.002 8.004 0.089 7.815 0.254 7.812L1.726 7.791C1.725 7.777 1.723 7.762 1.723 7.747Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.278 8.253C14.278 11.632 11.539 14.37 8.16 14.371C6.377 14.371 4.771 13.608 3.654 12.392C3.467 12.188 3.481 11.871 3.684 11.684C3.887 11.498 4.203 11.512 4.39 11.715C5.326 12.734 6.668 13.371 8.16 13.371C10.986 13.371 13.278 11.079 13.278 8.253C13.278 8.243 13.281 8.234 13.282 8.224L12.004 8.243C11.839 8.245 11.742 8.058 11.839 7.924L13.673 5.402C13.752 5.294 13.912 5.292 13.994 5.398L15.902 7.865C16.002 7.995 15.911 8.185 15.746 8.188L14.273 8.209C14.275 8.224 14.278 8.238 14.278 8.253Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.599 9.668C6.762 9.883 6.975 10.055 7.219 10.169C7.463 10.284 7.73 10.338 8 10.328C8.858 10.328 9.555 9.805 9.555 9.162C9.555 8.518 8.858 7.996 8 7.996C7.141 7.996 6.446 7.473 6.446 6.829C6.446 6.184 7.141 5.663 8 5.663C8.269 5.652 8.537 5.707 8.781 5.821C9.024 5.936 9.237 6.108 9.4 6.322",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.999 10.332V11.109",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.999 4.891V5.668",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPaymentProcessor;
